// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: center;
}

main {
  flex: 1 1;
  margin-top: 80px; /* Height of the fixed navbar */
}

h1, h2, h3, h4, h5, h6 {
  color: #2c3e50;
  line-height: 1.2;
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  cursor: pointer;
  font-family: inherit;
}

img {
  max-width: 100%;
  height: auto;
}

/* Utility Classes */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section {
  padding: 5rem 0;
}

.text-center {
  text-align: center;
}

/* Responsive Typography */
@media (max-width: 768px) {
  .section {
    padding: 3rem 0;
  }
}

.main-content {
  flex: 1 1;
  padding: 4rem 0;
  background-color: #f9f9f9;
}

.page-content {
  padding-top: 0px;
  min-height: calc(100vh - 80px);
}

.content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.left-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  order: 1;
}

.right-section {
  position: sticky;
  top: 2rem;
  height: fit-content;
  order: 2;
}

@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr;
    display: flex;
    flex-direction: column;
  }

  .right-section {
    position: static;
    order: 1;
  }

  .left-section {
    order: 2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAO;EACP,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  color: #333;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\nmain {\n  flex: 1;\n  margin-top: 80px; /* Height of the fixed navbar */\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: #2c3e50;\n  line-height: 1.2;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nbutton {\n  cursor: pointer;\n  font-family: inherit;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Utility Classes */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.section {\n  padding: 5rem 0;\n}\n\n.text-center {\n  text-align: center;\n}\n\n/* Responsive Typography */\n@media (max-width: 768px) {\n  .section {\n    padding: 3rem 0;\n  }\n}\n\n.main-content {\n  flex: 1;\n  padding: 4rem 0;\n  background-color: #f9f9f9;\n}\n\n.page-content {\n  padding-top: 0px;\n  min-height: calc(100vh - 80px);\n}\n\n.content-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.left-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  order: 1;\n}\n\n.right-section {\n  position: sticky;\n  top: 2rem;\n  height: fit-content;\n  order: 2;\n}\n\n@media (max-width: 768px) {\n  .content-grid {\n    grid-template-columns: 1fr;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .right-section {\n    position: static;\n    order: 1;\n  }\n\n  .left-section {\n    order: 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
